import React from "react";
import { Triangle } from "react-loader-spinner";
import "./ButtonTriangleSpinner.scss";

const ButtonTriangleSpinner = ({
  size = 22,
  color = "#ffffff",
  className = "",
}) => (
  <span
    className={`buttonTriangleSpinner ${className}`.trim()}
    aria-hidden="true"
  >
    <Triangle
      height={String(size)}
      width={String(size)}
      color={color}
      ariaLabel="loading"
      visible
    />
  </span>
);

export default ButtonTriangleSpinner;
